import PoliticaDetails from "./ComponentsPolitica/PoliticaDetais";
import Info from "../../components/Info/Info";
import Footer from "../../components/Footer/Footer";

export default function Politica(){
    return(
        <div>
            <PoliticaDetails/>
            <Info/>
            <Footer/>
        </div>
    )
}